import getEnvironment from "../getEnvironment";
import { FacetCountsDTO, MappedFacetCounts } from "./filters.type";
import { mapFacetCounts } from "./mapFacetCounts";

const getFacetCounts = async (
  url: string,
  authToken: string,
  isToUseAuthZero: boolean
): Promise<MappedFacetCounts[] | any> => {
  let headers: HeadersInit = {
    "Content-Type": "application/json",
  };

  if (isToUseAuthZero) {
    headers = {
      ...headers,
      Authorization: `Bearer ${authToken}`,
    };
  }

  if (getEnvironment() === "localhost" && !isToUseAuthZero) {
    if (!process.env.TOKEN) {
      console.log("TOKEN variable not set.");
    }

    headers = { ...headers, Authorization: `Bearer ${process.env.TOKEN}` };
  }

  let res: Response | undefined;

  try {
    res = await fetch(url, {
      method: "GET",
      headers,
    });

    if (!res.ok) {
      throw new Error(
        `An error (${res.status}) occurred while fetching the data.`
      );
    }

    const result: FacetCountsDTO = await res.json();
    return mapFacetCounts(result);
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export default getFacetCounts;
